import React from "react";
import StatsCards from "../../components/StatsCards";
import { toast } from "react-toastify";
import { useGetStatsQuery } from "../../store/api/callsApi";
import withPageFilters from "../../Layout/withPageFilters";
import Loader from "../../components/Loader/Loader";
import { useQueryParams } from "../../hooks/useQueryParams";
import { useClearDispositionFilterOnMount } from "../../hooks/useClearDispositionFilterOnMount";

const Reporting = ({
  filters,
  selectedCampaigns,
  selectedPublishers,
  selectedTargets,
  selectedBuyers,
}) => {
  useClearDispositionFilterOnMount();

  const queryParams = useQueryParams({
    filters,
    selectedCampaigns,
    selectedPublishers,
    selectedTargets,
    selectedBuyers,
  });

  const { data: stats, error, isLoading, isFetching } = useGetStatsQuery(queryParams, {
    refetchOnMountOrArgChange: true,
  });
  React.useEffect(() => {
    if (error) toast.error("Failed to fetch stats");
  }, [error]);

  if (isLoading) return <Loader message="Loading stats..." />;

  return (
    <div className={isFetching ? "opacity-75" : ""}>
      <StatsCards stats={stats || {}} />
    </div>
  );
};

export default withPageFilters(Reporting);
